import React, { Component } from 'react'

class NoSearchResults extends Component {
  render() {
    const { title, note } = this.props
    return (
      <div className='flex w-full items-center justify-center py-12'>
        <div className='flex flex-col w-3/5 items-center justify-center text-gray-8 text-center'>
          <p className='text-[23px] font-bold'>
            { title || 'There are no results currently for this search.' }
          </p>
          <p className='mt-3'>
            { note || 'Try removing filters or changing the search for samples, genres or instruments' }
          </p>
        </div>
      </div>
    )
  }
}

export default NoSearchResults;
